import React from "react";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import Layout from "./src/components/layout"
// import { GlobalProvider } from "./src/contexts/GlobalContext";

export const wrapPageElement = ({ element, props }: any) => {
    return <Layout {...props}>{element}</Layout>;
};
